<template>
    <div ref="container">
       <a-modal 
        :title="title" 
        width="95%" 
        :visible="visible" 
        :confirmLoading="confirmLoading" 
        :maskStyle="{'top':'93px','left':'154px'}" 
        :maskClosable="false" 
        @ok="handleOk" 
        @cancel="handleCancel"
        @closeModal="closeModal" 
        cancelText="关闭" 
        style="top:50px;height: 90%;"
        >
          <a-row class="processBox" :gutter="8">
            <a-col :col="6">
              <a-list @dragover.prevent @drop="handleDrop($event, 0, 'processFlow', null)">
                  <span class="processTitle">已绑定工序：</span>
                  <a-list-item 
                    v-for="(item, index) in processFlow" 
                    :key="index"
                    draggable="true"
                    @dragstart="handleDragStart(index, 'processFlow', item.processId)"
                    @dragover.prevent
                    @drop="handleDrop($event, index, 'processFlow', item.processId)"
                  >
                    <div class="processFlowList">
                      <span>{{ index + 1 }}</span> 
                      <span v-if="ids">{{ item.processId }}</span>
                      <span>{{ item.proceName }}</span>
                    </div>
                      
                  </a-list-item>
                  <!-- <a-empty v-if="processFlow.length === 0" description="将工序拖放到此处">
                  <template #image>
                    <a-icon type="file-search" style="font-size: 20px" />
                  </template>
                </a-empty> -->
              </a-list>
            </a-col>
            <a-col :col="6">
              <a-list>
                <span class="processTitle">所有工序：</span>
                <template v-if="processList.length > 0">
                  <a-list-item 
                    v-for="(item, index) in processList" 
                    :key="index"
                    :draggable="!isInProcessFlow(item.id)" 
                    @dragstart="handleDragStart(index, 'processList', item.id)"
                    @dragover.prevent
                    @drop="handleDrop($event, index, 'processList', item.id)"
                    :style="{ cursor: !isInProcessFlow(item.id) ? 'default' : 'not-allowed', opacity: !isInProcessFlow(item.id) ? 1 : 0.5 }"
                    
                  >
                    <div class="processFlowList">
                      <span>{{ index + 1 }}</span> 
                      <span v-if="ids">{{ item.id }}</span>
                      <span>{{ item.proceName }}</span>
                    </div>
                  </a-list-item>
                </template>
                <template v-else>
                  <a-list-item 
                      class="placeholder"
                      @dragover.prevent
                      @drop="handleDrop($event, 0, 'processList', null)"
                  >
                      <div class="processFlowList">
                          <span>将工序拖放到此处</span>
                      </div>
                  </a-list-item>
              </template>
              </a-list>
              <a-pagination
                style="margin-top: 16px; text-align: right;"
                :current="pagination.current"
                :pageSize="pagination.pageSize"
                :total="pagination.total"
                @change="handlePaginationChange"
                showSizeChanger
                :pageSizeOptions="['10', '20', '30']"
                showTotal="(total) => `共 ${total} 条`"
            />
            </a-col>
          </a-row>
        </a-modal>
    </div>
</template>
<script>
// import pick from 'lodash.pick'
// import process from '@/views/trace/process';
import { bindingProcess, getAll, queryProcessByCraftId } from '@/api/api'
export default {
  name: 'CustomerModal',
  components: {
    // process
  },
  data () {
    return {
      title: '选择工序',
      visible: false, 
      confirmLoading: false,
      ids: false,
      traceVueModule: null,
      form: this.$form.createForm(this),
      processFlow: [],
      draggedFrom: null,
      processList: [],
      draggedItem: null,
      // draggedFrom: null,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
      },
      formModule:[],
      selectProcess:[],
      traceModuleForm: {},
      getCraftIdFromFather: '',
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    paginatedProcessList() {
        const { current, pageSize } = this.pagination;
        const start = (current - 1) * pageSize;
        const end = start + pageSize;
        return this.processList.slice(start, end);
    }
  },
    methods: {
        open(data){
            this.visible = true
            this.getCraftIdFromFather = data
            console.log(this.getCraftIdFromFather,'获取的record的规则ID==============')
            this.getProcessList()
            this.getBindProcessList(this.getCraftIdFromFather.id)
        },
        show(data){
            this.traceVueModule = data
        },
        isInProcessFlow(id) {
          return this.processFlow.some(flowItem => flowItem.id === id || flowItem.processId === id);
        },
        handleDragStart(index, listName, id) {
          if (listName === 'processList') {
            const item = this[listName][index];
            const existsInProcessFlow = this.processFlow.some(flowItem => flowItem.id === item.id || flowItem.processId === item.id);
            if (existsInProcessFlow) {
              console.log('该工序已经在左侧绑定列表中，禁止拖拽');
              return; // 不允许拖动
            }
          }
          this.draggedItem = this[listName][index];
          // this.draggedId = id || processId;
          this.draggedId = id || this.draggedItem.processId; // 确保使用正确的属性
          this.draggedFrom = listName;
        },
        handleDrop(event, index, listName, id) {
          
          event.preventDefault();
          // 其他项目可以在不同列表之间移动
          if (this.draggedFrom === listName) {
              this[listName].splice(index, 0, this[listName].splice(this[listName].indexOf(this.draggedItem), 1)[0]);
            } else {
              const fromList = this[this.draggedFrom];
              const toList = this[listName];
              const itemIndex = fromList.indexOf(this.draggedItem);
              const item = fromList.splice(itemIndex, 1)[0];

              if (listName === 'processFlow') {
                // 检查是否已经存在相同 id 或 processId 的项目
                const existsInProcessFlow = toList.some(flowItem => flowItem.id === item.id || flowItem.processId === item.id);
                if (existsInProcessFlow) {
                  console.log('该工序已经在左侧绑定列表中，禁止添加');
                  return; // 不允许添加
                }
              }
              // 将工序添加到目标列表
              // toList.splice(index, 0, item);
              const existingItemIndex = toList.findIndex((existing) => existing.proceName === item.proceName);
              if (existingItemIndex !== -1) {
                console.log('工序已存在，合并');
                // 合并逻辑可以根据需要实现，这里假设合并时不需要特殊处理
                // 如果需要特殊处理（例如合并属性），可以在这里添加逻辑
              } else {
                console.log('工序不存在，添加到目标列表');
                toList.splice(index, 0, item);
              }
            }
          this.draggedItem = null;
          this.draggedId = null;
          this.draggedFrom = null;
        },
        // 新增方法：获取 processFlow 列表的序号和名称
        getProcessFlowDetails() {
          this.processFlow.forEach((item, index) => {
            console.log(`序号: ${index + 1}, id: ${item.id || item.processId},名称: ${item.proceName }`);
          });
        },
        add(data) {
          this.traceModuleForm = data
          this.visible = true;
          this.$nextTick(() => {
            if (this.$refs.traceModules && typeof this.$refs.traceModules.showDialog === 'function') {
              this.$refs.traceModules.showDialog(data);
            } else {
              console.error('traceModules 或 showDialog 未正确初始化');
            }
          });
          this.getFormArray(data)
        },
        // 获取表单数据
        async getFormArray(data){
          const res = await traceModuleDetail(data)
          if( res.code == 200 && res.success == true ){
              this.formModule = res.result.formArray
              this.traceVueModule = res.result.formArray
          }
        },
        handleGetDrawingList(drawingList){
          // 在这里处理接收到的 drawingList 数据
          this.formModule = drawingList
        },
        // 查询所有工序
        async getProcessList(){
          const params = {
            proceName: '',
            segmentType: 1,
            pageNo: this.pagination.current,
            pageSize: this.pagination.pageSize,
          }
          const res = await getAll(params)
          if( res.code == 200 && res.success == true ){
              this.processList = res.result.records
          }
        },
        // 查询绑定的工序 getBindProcessList
        async getBindProcessList(id){
          const params = {
            craftId: id
          }
          const res = await queryProcessByCraftId(params)
          if( res.code == 200 && res.success == true ){
              this.processFlow = res.result
              console.log(this.processFlowm,'this.processFlow===============获取绑定工序列表')
          }
        },
        async handleOk() {
          this.processFlow.forEach((item, index) => {
            
            this.selectProcess.push(
              {
                craftId: this.getCraftIdFromFather.id,
                processId: item.id || item.processId,
                seq: `${index + 1}`
              }
            )
          });
          const params = {
            list : this.selectProcess,
            craftId: this.getCraftIdFromFather.id
          }
          const res = await bindingProcess(params)
          this.visible = false;
          if( res.code == 200 && res.success == true ){
            this.visible = false;
            this.selectProcess = []
          }
        },
        handleCancel(){
          this.visible = false;
          this.resetCurrentStepInChild();
          this.selectProcess = []
        },
        closeModal(){
          this.visible = false;
        },
        resetCurrentStepInChild() {
          if (this.$refs.traceCode) {
            this.$refs.traceCode.resetCurrentStep();
          }
        },
        handlePaginationChange(page, pageSize) {
          this.pagination.current = page;
          this.pagination.pageSize = pageSize;
        }
    }
}
</script>
<style lang="less" scoped>
  .processBox{
    display: flex;
    justify-content: space-between;
    .ant-col{
      height: 100%;
      width: 48%;
      border: 1px solid #ededed;
      border-radius: 5px;
      padding: 10px;
    }
    .processFlowList {
      justify-content: flex-start;
      span {
        margin-right: 10px;
      }
    }
    .processTitle {
      display: block;
      line-height: 40px;
      border-bottom: 1px dashed #ededed;
      color: green;
    }
    .not-allowed-item {
      pointer-events: none;
      opacity: 0.5;
    }
  }
</style>